<template>
  <div class="mdg">
    <!-- “mdg”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- mdg -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/masterData/mdg';
  export default {
    name: 'mdg',
    mixins: [tableMixins],
    computed: {
      searchColumns() {
        return [
          {
            name: '关联数据编码',
            prop: 'sendDataKey',
            type: 'input',
          },
          {
            name: '推送时间从',
            prop: 'sendTimeStart',
            type: 'startDaterangePickerTime',
          },
          {
            name: '推送时间到',
            prop: 'sendTimeEnd',
            type: 'endDaterangePickerTime',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          sendDataKey: null,
          sendTimeStart: null,
          sendTimeEnd: null,
        },
        columnListDefault: [
          {
            field: 'sendTime',
            title: '发送时间',
            visible: true,
            fixed: 'left',
          },
          {
            field: 'sendModel',
            title: '关联模块',
            visible: true,
          },
          {
            field: 'resultMsg',
            title: '操作结果',
            visible: true,
          },
          {
            field: 'resultMsgReason',
            title: '结果产生原因',
            visible: true,
          },
          {
            field: 'sendDataKey',
            title: '关联key',
            visible: true,
          },
          {
            field: 'sendData',
            title: '发送数据',
            visible: true,
          },
          {
            field: 'sendStatus',
            title: '推送状态',
            visible: true,
            dictType: 'mdgSendStatus',
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      // 获取列表数据
      async getData() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        this.load = true;
        let res = await this.$axios.post(API.QUERY_MDG_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
    },
  };
</script>
